import moment from 'moment';
import { get } from 'lodash';

import { defaultCreditCardReference, apiDateFormat } from '../../config';
import { paymentFrequencyOptions } from '../../config/paymentFrequencyOptions';

export const formatDate = (date) => moment(date).format(apiDateFormat);

export const getApprovers = (payment) => {
	const userList = get(payment, 'approverId', '');
	return userList ? { approver_id: [payment.approverId] } : {};
};

export const getReference = ({ reference = undefined, toAccountDetails }) => {
	const type = get(toAccountDetails, 'type', '');
	if (type === 'credit_card') return { reference: defaultCreditCardReference };
	if (reference === '') return undefined;
	return { reference };
};

export const getPaymentInstructionId = (payment) => {
	const paymentInstructionId = get(payment, 'paymentInstructionId');
	return paymentInstructionId ? { payment_instruction_id: paymentInstructionId } : undefined;
};

export const getAmount = (payment) => ({
	amount: {
		value: parseFloat((payment.amount || '').replace(/,/g, '')) || 0.0,
		currency: 'GBP',
	},
});

export const getPaymentsTotal = (payments) =>
	payments.reduce((all, payment) => {
		const parseAmount = (value) => parseFloat(value.replace(/,/g, ''));

		if (payment.fromAccount in all) {
			all[payment.fromAccount] = all[payment.fromAccount] + parseAmount(payment.amount);
		} else {
			all[payment.fromAccount] = parseAmount(payment.amount);
		}
		return all;
	}, {});

export const removeDuplicateFromaccounts = (payments) =>
	payments.filter(
		(value, index, self) => index === self.findIndex((payment) => payment.fromAccount === value.fromAccount)
	);

export const getEndConditionDetails = (payment) => {
	switch (payment.stopPaymentOption) {
		case 'on-date':
			return {
				end_condition: {
					when: formatDate(payment.stopPaymentOnDate),
				},
			};
		case 'on-number':
			return {
				end_condition: {
					number_of_payments: Number(payment.stopPaymentOnNumber),
				},
			};
		default:
			return null;
	}
};

export const getSingleDetails = (payment) => ({
	single: {
		when: formatDate(payment.date),
		...getAmount(payment),
	},
});

export const getFrequency = (payment) => {
	const { frequency } = payment;
	return get(
		paymentFrequencyOptions.filter((x) => x.value === frequency),
		'[0].request',
		{}
	);
};

export const getScheduleDetails = (payment) => ({
	schedule: {
		start_condition: {
			when: formatDate(payment.date),
		},
		recurrence: {
			frequency: { ...getFrequency(payment) },
			...getAmount(payment),
		},
		...getEndConditionDetails(payment),
	},
});

export const getApproversPayload = (namedApprovers, groupApprovers) =>
	!!namedApprovers.approver_id.length
		? namedApprovers
		: !!groupApprovers.approval_group_approver_id.length
		? groupApprovers
		: null;
